import React, { useContext, useState } from 'react'
import { Form, Button, Spinner } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { createFeedback }  from '../Network/Feedback'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import "./Feedback.css"

function Feedback({ onCancel }) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.feedback

    const [isLoading, setLoading] = useState(false)
    const [isFinish, setFinish] = useState(false)
    const [title, setTitle] = useState("")
    const [detail, setDetail] = useState("")
    const [isError, setError] = useState(false)
    const [attachImage, setAttachImage] = useState(null)

    const submitFeedback = () =>{
        if(!title || !detail){
            setError(true)
            return
        }

        setLoading(true)
        createFeedback(title, detail, attachImage,
            ()=>{ 
                setFinish(true)
                setLoading(false)
            },
            (error)=>{  })
    }

    return (
        <div id="feedback">
            { isLoading ?
            <div className="load-screen">
                <Spinner animation="border" variant="primary"/>
            </div>
            : null
            }
            { !isFinish ?
            <div>
                <div>{lang.send_feedback_desc}</div>
                <div className="feedback-container">
                    <Form 
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submitFeedback()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.title}</Form.Label>
                            <Form.Control
                            value={title}
                            isInvalid={!title && isError}
                            onChange={(e)=>setTitle(e.target.value)}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.detail}</Form.Label>
                            <Form.Control 
                            as="textarea" 
                            value={detail}
                            isInvalid={!detail && isError}
                            onChange={(e)=>setDetail(e.target.value)}
                            style={{ 
                                height: 150 ,
                                whiteSpace: 'pre-wrap'
                            }}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.attach_file}</Form.Label>
                            <Form.File
                            onChange={(e)=>{
                                let toUpload = e.target.files[0]
                                setAttachImage(toUpload)
                            }}
                            />
                        </Form.Group>
                        <hr/>
                        <div style={{ textAlign: 'center' }}>
                            <Button 
                            type="submit" 
                            disabled={isLoading}>
                                {lang.send_feedback}
                            </Button>
                            <Button 
                            variant="secondary" 
                            style={{ marginLeft: 10 }} 
                            disabled={isLoading}
                            onClick={onCancel}>
                                {lang.cancel}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
            :
            <div className="finish-container">
                <div className="icon">
                    <FontAwesomeIcon icon={faCheckCircle}/>
                </div>
                <div>
                    <div className="title">{lang.thank_you}</div>
                    <div className="desc">{lang.feedback_finish_desc}</div>
                    <div style={{ marginTop: 20 }}>
                        <Button onClick={onCancel}>{lang.finish}</Button>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default Feedback
